import * as types from '@/store/types'

export default function checkNotSignUp({ next, store }) {
  const name = types.SESSION
  const { isSignup } = store.state[name].model

  // Если переход происходит не после регистрации
  if (!isSignup) {
    next()
    return
  }
  store.commit(types.UPDATE_MODEL, { model: { isSignup: false }, name })
  next({ name: 'placements' })
}
